import Api from './baseApi';

export default {
    getInventoryItems: (type) => {
        let url = '/api/inventory';
        if (type !== undefined && type !== null) url += `?type=${type}`;
        return Api.get(url);
    },
    getTotalHas: () => Api.get('/api/inventory/totalHas'),
    addKulce: (dto) => Api.post('/api/inventory/kulce', dto),
    addZiynet: (dto) => Api.post('/api/inventory/ziynet', dto),
    addTaki: (dto) => Api.post('/api/inventory/taki', dto),
    getJewelryItems: (status, search, size, weightRounded, purity) => {
        let url = '/api/inventory/jewelry?v=1';
        if (status !== undefined && status !== null) url += `&status=${status}`;
        if (search) url += `&search=${encodeURIComponent(search)}`;
        if (size) url += `&size=${encodeURIComponent(size)}`;
        if (weightRounded !== undefined && weightRounded !== null) url += `&weightRounded=${weightRounded}`;
        if (purity !== undefined && purity !== null && purity !== '') url += `&purity=${encodeURIComponent(purity)}`;
        return Api.get(url);
    },
    getJewelryTotalHas: (status, size, weightRounded, purity) => {
        let url = '/api/inventory/jewelry/totalHas';
        const params = [];
        if (status !== undefined && status !== null) params.push(`status=${status}`);
        if (size) params.push(`size=${encodeURIComponent(size)}`);
        if (weightRounded !== undefined && weightRounded !== null) params.push(`weightRounded=${weightRounded}`);
        if (purity !== undefined && purity !== null && purity !== '') params.push(`purity=${encodeURIComponent(purity)}`);
        if (params.length) url += '?' + params.join('&');
        return Api.get(url);
    },
    deleteJewelryItem: (id) => Api.delete(`/api/inventory/jewelry/${id}`),
    updateJewelryStatus: (id, dto) => Api.patch(`/api/inventory/jewelry/${id}/status`, dto),
}
